import { DuotoneIcon, type DuotoneIconProps } from './DuotoneIcon';

export function ShiftsIcon(props: Omit<DuotoneIconProps, 'name'> & { name?: DuotoneIconProps['name'] }) {
  return <DuotoneIcon name="list-timeline" {...props} />;
}
